/* eslint-disable eqeqeq */

import request from '../utils/request';
import { routerRedux } from 'dva/router';
import Config,{MethodType} from '../config'

let wiexin ={
        namespace:'weixin',
        state:{
            appid:'',
            code:'',
            access_token:'',
            expires_in :'',
            openid:'',
            nickname :'',
            headimgurl : '',
            message : null
        },
        effects:{  //异步action
            *test({payload},{call,put}){
                
                let res = yield call(request('api/values',{
                   method: MethodType.GET,
                   params:payload
               }));
               return res
            },
            //通过code换取网页授权access_token
            *access_token({payload},{call,put}){
             let res =   yield call(request('wx/AccessToken',{
                   method: MethodType.GET,
                   params:{...payload}
               }));
              
                if(res.data.access_token)
                {
                    localStorage.setItem("access_token",res.data.access_token);
                    localStorage.setItem("refresh_token",res.data.refresh_token);
                    localStorage.setItem("openid",res.data.openid);

                    yield put({type:'update',payload:{access_token:res.data.access_token,
                                                            openid:res.data.openid}});
                }
                
                
            },
            //刷新access_token（如果需要）
            *refreshToken({payload},{call,put}){
                     yield call(request('wx/RefreshToken',{
                      method: MethodType.GET,
                      params:{...payload}
                  }));
               },
            

             //拉取用户信息(需scope为 snsapi_userinfo)
            *userinfo({payload},{call,put,take}){
                let res =   yield call(request('wx/getUserInfo',{
                      method: MethodType.GET,
                      params:{...payload}
                  }));
                  if(res.data.nickname)
                {
                    localStorage.setItem("nickname",res.data.nickname);
                    localStorage.setItem("headimgurl",res.data.headimgurl);

                    yield put({type:'update',payload:{nickname:res.data.nickname,
                                                      headimgurl:res.data.headimgurl}});
                }
                  yield put(routerRedux.push('/app'))
               },
                  
               //检验授权凭证（access_token）是否有效
                   //   正确的JSON返回结果：
        //    { "errcode":0,"errmsg":"ok"}
            *auth({payload},{call,put}){
                     yield call(request('wx/Auth',{
                      method: MethodType.GET,
                      params:{...payload}
                  }));
               },

               *changeRouter({payload},{call,put}){
              
                yield put(routerRedux.push(payload.route))
               },
               //绑定手机号
               *saveBindPhone({payload},{call,put}){
                  let res =  yield call(request('xlc/basic/BindPhone',{
                        method: MethodType.POST,
                        params:{appid:Config.appid,
                          data:{...payload}
                        }
                    }));
                    if(res.data.codes=="NOERROR")
                    {
                        localStorage.setItem("AAA201",res.data.AAA201);  //客户ID
                        localStorage.setItem("AAA001",res.data.AAA001);  //供应商ID
                        localStorage.setItem("AAA004",res.data.AAA004);  //供应商名称
                        localStorage.setItem("AAC002",res.data.AAC002);  //客户编号
                        localStorage.setItem("AAC003",res.data.AAC003);  //客户名称
                  
                        yield put(routerRedux.push('/home'))
                    }else{
            
                        yield put({type:'update',payload:{message:res.data.message}});
                    }

               },
               *getBindPhone({payload},{call,put}){
                   let res = yield call(request('xlc/basic/BindPhone',{
                       method:MethodType.GET,
                       params:{appid:Config.appid,
                        data:{...payload}
                       }
                   }));

                   if(res.data.codes=="NOERROR")
                   {
                       localStorage.setItem("AAA201",res.data.AAA201);  //客户ID
                       localStorage.setItem("AAA001",res.data.AAA001);  //供应商ID
                       localStorage.setItem("AAA004",res.data.AAA004);  //供应商名称
                       localStorage.setItem("AAC002",res.data.AAC002);  //客户编号
                       localStorage.setItem("AAC003",res.data.AAC003);  //客户名称
                 
                       yield put(routerRedux.push('/home'))
                   }else{
           
                       yield put({type:'update',payload:{message:res.data.message}});
                   }


               }
        },
        reducers:{ 
            update(state, { payload }) {
                return {
                    ...payload
                }
            },
        }
};

export default wiexin;